<div>
  <app-page-header [showCustomerSpaceName]="false" [hasImage]="false" [backLink]="['/', 'admin']"></app-page-header>
  <h1 class="label">{{ 'admin.user-management.title' | translate }}</h1>
</div>
<app-users-management-table [users]="userDataSource.data">
</app-users-management-table>
